import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-form-footer',
  templateUrl: './form-footer.component.html',
  styleUrls: ['./form-footer.component.scss']
})
export class FormFooterComponent implements OnInit {

  hide: boolean = false;

  @Input()
  isChild: boolean = false;

  @Output()
  onFormClose = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  close(reset: boolean) {
    this.onFormClose.emit(reset);
  }
  hideAll(){
    this.hide = true;
  }


}



// WEBPACK FOOTER //
// ./src/app/form/core/component/form-footer/form-footer.component.ts